import qs from "qs";
import axios from "axios";
import { URL } from "../../../../constants/Constants";

/**
 * Obtiene movimientos de recuperación de merma
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @param {Array} mos - Array de MOs
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getMovimientosRecMerma = async (queryType, query_param, mos) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
  };

  try {
    const response = await axios.post(
      URL,
      qs.stringify(queryData, { arrayFormat: "brackets" }),
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }
    );

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta recuperación de merma
 * @param {string} queryType - Tipo de consulta
 * @param {string} queryParam - Parámetro de consulta
 * @param {string} usuario - Usuario
 * @param {Array} data - Datos
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertRecMerma = async (queryType, queryParam, usuario, data) => {
  try {
    const formData = new FormData();

    formData.append("query_type", queryType);
    formData.append("query_param", queryParam);
    formData.append("user", usuario);

    formData.append("data", JSON.stringify(data));

    if (data[0]?.imagen) {
      formData.append("imagen", data[0].imagen);
    }

    const response = await axios.post(URL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.error("Error en la respuesta:", response.data);
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta datos de recuperación perdidos
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @param {string} data - Datos
 * @returns {Promise<boolean>} true si se procesaron correctamente, false en caso contrario
 */
export const insertRecoveryLostData = async (queryType, query_param, data) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
    data: data,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (
      response.data.status === "success" ||
      response.data.status === "duplicate"
    ) {
      console.log(
        "Datos enviados exitosamente o ya existentes:",
        response.data.message
      );
      return true;
    } else {
      console.log("Error en la respuesta del servidor:", response.data.message);
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
